// Guild Marine redesign: header, menu, search and cart count for pages that use layout/theme.liquid.
(() => {
  const $ = id => document.getElementById(id);
  const top = document.querySelector('.gm-top');
  if (!top) return;

  // ---------- menu ----------
  const dr = $('gm-drawer'), mb = $('gm-menu-btn');
  const setMenu = (o, back) => {
    if (o === dr.classList.contains('open')) return;
    dr.classList.toggle('open', o); dr.setAttribute('aria-hidden', !o); mb.setAttribute('aria-expanded', o); document.body.style.overflow = o ? 'hidden' : '';
    if (o) requestAnimationFrame(() => $('gm-menu-x').focus()); else if (back) mb.focus();
  };
  mb.addEventListener('click', () => setMenu(true));
  $('gm-menu-x').addEventListener('click', () => setMenu(false, true));
  dr.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));

  // ---------- header: hides on scroll down, returns on scroll up ----------
  let lastY = scrollY, queued = false;
  addEventListener('scroll', () => {
    if (queued) return; queued = true;
    requestAnimationFrame(() => {
      queued = false;
      const y = scrollY;
      if (Math.abs(y - lastY) > 6) { top.classList.toggle('is-hidden', y > 200 && y > lastY && !dr.classList.contains('open')); lastY = y; }
    });
  }, { passive: true });

  // ---------- search (Shopify predictive search) ----------
  const sEl = $('gm-search'), sIn = $('gm-s-input'), sOut = $('gm-s-results');
  const POPULAR = ['Alexseal 501', 'Gelcoat', 'Garmin', 'Raymarine Axiom', 'Furuno', 'Anodes', 'Peel ply', 'Bilge pump'];
  const COLLECTIONS = [['Alexseal Coatings','/collections/alexseal'],['Electronics','/collections/marine-navigation-instruments'],['Fiberglass & Composites','/collections/composites'],['Engine & Mechanical','/collections/engine-mechanical'],['Hardware','/collections/marine-hardware'],['Safety','/collections/marine-safety'],['Electrical','/collections/electrical'],['Lighting','/collections/lighting'],['Anchoring & Docking','/collections/anchoring-docking'],['Plumbing & Pumps','/collections/marine-plumbing-ventilation'],['Clearance','/collections/clearance']];
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const hl = (t, q) => { let h = esc(t); q.split(/\s+/).filter(w => w.length > 1).forEach(w => { h = h.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); }); return h; };
  const money = p => '$' + Number(p).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const allUrl = q => `/search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
  let seq = 0, active = -1, lastQ = null, timer, lastFocus = null;

  const chips = list => `<div class="gm-chips">${list}</div>`;
  const renderIdle = () => {
    active = -1;
    sOut.innerHTML = `<div class="gm-s-sec"><span class="gm-label">Popular</span>${chips(POPULAR.map(p => `<button type="button" data-q="${esc(p)}">${esc(p)}</button>`).join(''))}</div>` +
      `<div class="gm-s-sec"><span class="gm-label">Browse</span>${chips(COLLECTIONS.map(([t, u]) => `<a href="${u}">${esc(t)}</a>`).join(''))}</div>`;
  };
  const run = async () => {
    const q = sIn.value.trim(), my = ++seq;
    if (!q) return renderIdle();
    let r = { products: [], collections: [] };
    try {
      const j = await (await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`)).json();
      const res = j.resources.results;
      r = { products: res.products.map(p => ({ t: p.title, u: p.url.split('?')[0], v: p.vendor, p: p.price, i: p.image })), collections: (res.collections || []).map(c => [c.title, c.url.split('?')[0]]) };
    } catch {}
    if (my !== seq) return;
    active = -1;
    sOut.innerHTML = (r.collections.length ? `<div class="gm-s-sec"><span class="gm-label">Collections</span>${chips(r.collections.map(([t, u]) => `<a href="${u}">${esc(t)}</a>`).join(''))}</div>` : '') +
      `<div class="gm-s-sec"><span class="gm-label">Products</span>` +
      (r.products.length
        ? `<div class="gm-s-grid">${r.products.map(p => `<a class="gm-s-item" href="${p.u}"><span class="gm-s-img">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy">` : ''}</span><span><span class="gm-s-v">${esc(p.v || '')}</span><span class="gm-s-t">${hl(p.t, q)}</span></span><span class="gm-s-p">${money(p.p)}</span></a>`).join('')}</div>`
        : `<p class="gm-s-empty">Nothing matched “${esc(q)}”. Try a part number or brand, or <a class="gm-u" href="/pages/contact">ask us to source it</a>.</p>`) +
      `<a class="gm-label gm-u gm-s-all" href="${allUrl(q)}">See all results for “${esc(q)}” →</a></div>`;
  };
  const queue = () => { if (sIn.value === lastQ) return; lastQ = sIn.value; clearTimeout(timer); timer = setTimeout(run, 140); };
  sIn.addEventListener('input', queue);
  sIn.addEventListener('keyup', e => { if (!/Arrow|Enter|Escape/.test(e.key)) queue(); });
  sOut.addEventListener('click', e => { const b = e.target.closest('[data-q]'); if (b) { sIn.value = b.dataset.q; lastQ = sIn.value; run(); sIn.focus(); } });
  $('gm-s-form').addEventListener('submit', e => { e.preventDefault(); const q = sIn.value.trim(); if (q) location.href = allUrl(q); });

  const openSearch = () => {
    lastFocus = document.activeElement; setMenu(false);
    sEl.classList.add('open'); sEl.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    sIn.value = ''; lastQ = ''; renderIdle(); requestAnimationFrame(() => sIn.focus());
  };
  const closeSearch = () => {
    if (!sEl.classList.contains('open')) return;
    sEl.classList.remove('open'); sEl.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  document.querySelectorAll('[data-gm-search]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openSearch(); }));
  $('gm-search-x').addEventListener('click', closeSearch);

  // keep Tab inside the open menu or search overlay
  const trapIn = (box, e) => {
    const f = [...box.querySelectorAll("a[href], button, input:not([type=hidden]), select, textarea")].filter(el => getComputedStyle(el).visibility !== "hidden" && el.getClientRects().length);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  addEventListener("keydown", e => { if (e.key !== "Tab") return; if (sEl.classList.contains("open")) trapIn(sEl, e); else if (dr.classList.contains("open")) trapIn(dr, e); });
  addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeSearch(); setMenu(false, true); return; }
    if (e.key === '/' && !sEl.classList.contains('open') && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) { e.preventDefault(); openSearch(); }
    if (!sEl.classList.contains('open') || !/ArrowDown|ArrowUp/.test(e.key)) return;
    const items = [...sOut.querySelectorAll('.gm-s-item')]; if (!items.length) return;
    e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
    items.forEach((el, i) => el.classList.toggle('act', i === active)); items[active].scrollIntoView({ block: 'nearest' });
  });
  sIn.addEventListener('keydown', e => { if (e.key === 'Enter' && active > -1) { e.preventDefault(); sOut.querySelectorAll('.gm-s-item')[active].click(); } });

  // ---------- cart count: refresh whenever Flex (or anything else) changes the cart ----------
  const setCount = n => document.querySelectorAll('[data-gm-cart-count]').forEach(el => { el.textContent = n; });
  const refresh = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => setCount(c.item_count)).catch(() => {});
  const isCartCall = u => /\/cart\/(add|change|update|clear)/.test(String(u && u.url || u));
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (...a) => nativeFetch(...a).then(r => { if (isCartCall(a[0])) setTimeout(refresh, 250); return r; });
  const hookJq = () => { if (window.jQuery) jQuery(document).ajaxComplete((e, x, s) => { if (isCartCall(s.url)) refresh(); }); };
  if (window.jQuery) hookJq(); else addEventListener('load', hookJq);
  addEventListener('pageshow', e => { if (e.persisted) refresh(); });
})();

// ================= redesign page behaviors =================
(() => {
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const setCount = n => $$('[data-gm-cart-count]').forEach(el => { el.textContent = n; });
  const refreshCount = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => setCount(c.item_count)).catch(() => {});

  // quantity steppers (product + cart)
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-gm-qty]'); if (!b) return;
    const input = b.parentElement.querySelector('input'); if (!input) return;
    const min = +(input.min || 0);
    input.value = Math.max(min, (+input.value || 0) + +b.dataset.gmQty);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // quick add on product cards
  document.addEventListener('click', async e => {
    const b = e.target.closest('.pc-add[data-variant]'); if (!b) return;
    const label = b.dataset.label || 'Add to cart';
    b.disabled = true; b.textContent = 'Adding…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.variant, quantity: 1 }] }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Could not add');
      await refreshCount();
      b.textContent = 'Added ✓'; b.classList.add('done');
    } catch (err) { b.textContent = 'Unavailable'; }
    setTimeout(() => { b.textContent = label; b.classList.remove('done'); b.disabled = false; }, 2200);
  });

  // ---------- product page ----------
  const root = document.querySelector('[data-gm-product]');
  if (root) {
    const data = JSON.parse(root.querySelector('[data-gm-product-json]').textContent);
    const form = root.querySelector('[data-product-form]');
    const idInput = form.querySelector('[data-gm-variant-input]');
    const btn = form.querySelector('[data-add-to-cart-trigger]');
    const btnText = btn.querySelector('.text');
    const note = form.querySelector('[data-special-order-note]');
    const msg = form.querySelector('[data-gm-msg]');
    const force = root.dataset.specialForce === 'true';
    const gallery = root.querySelector('[data-gm-gallery]');

    const showMedia = id => {
      if (!gallery || !id) return;
      const item = gallery.querySelector(`.gm-gal__item[data-media-id="${id}"]`); if (!item) return;
      $$('.gm-gal__item', gallery).forEach(el => el.classList.toggle('on', el === item));
      $$('[data-thumb]', gallery).forEach(el => el.classList.toggle('on', el.dataset.thumb == id));
      $$('video', gallery).forEach(v => { if (!item.contains(v)) v.pause(); });
    };
    if (gallery) gallery.addEventListener('click', e => { const t = e.target.closest('[data-thumb]'); if (t) showMedia(t.dataset.thumb); });

    const selected = () => $$('[data-gm-option]', form).map(g => { const c = g.querySelector('input:checked'); const s = g.querySelector('select'); return c ? c.value : s ? s.value : null; });
    const update = () => {
      const opts = selected();
      const v = data.variants.find(x => x.options.every((o, i) => o === opts[i]));
      $$('[data-gm-option]', form).forEach((g, i) => { const l = g.querySelector('[data-gm-option-label]'); if (l) l.textContent = opts[i]; });
      // mark option values that have no available variant given the other selections
      $$('[data-gm-option]', form).forEach((g, i) => $$('input', g).forEach(inp => {
        const test = opts.slice(); test[i] = inp.value;
        const ok = data.variants.some(x => x.available && x.options.every((o, j) => o === test[j]));
        const lab = g.querySelector(`label[for="${inp.id}"]`); if (lab) lab.classList.toggle('na', !ok);
      }));
      msg.className = 'gm-msg'; msg.textContent = '';
      if (!v) { btn.disabled = true; btnText.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      root.querySelector('[data-gm-price-now]').textContent = v.price;
      const was = root.querySelector('[data-gm-price-was]'), save = root.querySelector('[data-gm-price-save]');
      was.hidden = save.hidden = !v.compare; if (v.compare) was.textContent = v.compare;
      const sku = root.querySelector('[data-gm-sku]'); sku.hidden = !v.sku; sku.querySelector('span').textContent = v.sku || '';
      const special = v.available && (force || (v.m === 1 && v.q <= 0));
      btn.disabled = !v.available;
      btn.classList.toggle('gm-b--special', special); btn.classList.toggle('button--special-order', special);
      btnText.textContent = !v.available ? 'Sold out' : (special ? btn.dataset.labelSpecial : btn.dataset.labelNormal);
      if (note) note.hidden = !special;
      if (v.media) showMedia(v.media);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    form.addEventListener('change', e => { if (e.target.closest('[data-gm-option]')) update(); });

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (btn.disabled) return;
      const before = btnText.textContent;
      btn.disabled = true; btnText.textContent = 'Adding…';
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        await refreshCount();
        msg.className = 'gm-msg gm-msg--ok';
        msg.innerHTML = `Added to cart. <a href="/cart">View cart</a> · <a href="/checkout">Checkout</a>`;
      } catch (err) {
        msg.className = 'gm-msg gm-msg--err'; msg.textContent = err.message;
      }
      btn.disabled = false; btnText.textContent = before;
    });
  }

  // ---------- recommendations ----------
  const recs = document.querySelector('[data-gm-recs]');
  if (recs && recs.dataset.url && !recs.querySelector('.pc')) {
    fetch(recs.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-gm-recs]');
      if (fresh && fresh.querySelector('.pc')) { recs.innerHTML = fresh.innerHTML; recs.hidden = false; } else recs.hidden = true;
    }).catch(() => { recs.hidden = true; });
  }

  // ---------- cart page: save quantities as they change ----------
  const cartForm = document.getElementById('gm-cart-form');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', e => {
      if (!e.target.matches('[data-gm-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(() => { const h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1'; cartForm.appendChild(h); cartForm.submit(); }, 600);
    });
  }

  // ---------- collection: filters drawer + sort ----------
  const cform = document.getElementById('gm-cform');
  if (cform) {
    const fd = document.getElementById('gm-fd');
    const setFd = o => { if (!fd) return; fd.classList.toggle('open', o); fd.setAttribute('aria-hidden', !o); document.body.style.overflow = o ? 'hidden' : ''; };
    $$('[data-gm-filters-open]').forEach(b => b.addEventListener('click', () => setFd(true)));
    $$('[data-gm-filters-close]').forEach(b => b.addEventListener('click', () => setFd(false)));
    addEventListener('keydown', e => { if (e.key === 'Escape') setFd(false); });
    cform.addEventListener('submit', () => { $$('input', cform).forEach(i => { if ((i.type === 'number' || i.type === 'text') && i.value === '') i.disabled = true; }); });
    $$('[data-gm-autosubmit]', cform).forEach(s => s.addEventListener('change', () => cform.requestSubmit ? cform.requestSubmit() : cform.submit()));
  }

  // ---------- project gallery ----------
  const pj = document.querySelector('[data-gm-projects]');
  if (pj) {
    const grid = pj.querySelector('[data-gm-proj-grid]');
    if (grid) {
      const cards = $$('a', grid).sort((a, b) => (b.dataset.date || '').localeCompare(a.dataset.date || ''));
      cards.forEach(c => grid.appendChild(c));
      const chips = $$('[data-filter]', pj);
      chips.forEach(chip => chip.addEventListener('click', () => {
        const f = chip.dataset.filter;
        chips.forEach(c => { const on = c === chip; c.classList.toggle('on', on); c.setAttribute('aria-pressed', on); });
        cards.forEach(card => { card.hidden = !(f === 'all' || card.dataset.services.includes('|' + f + '|')); });
      }));
    }
  }
})();
